export default function StepWelcome({ onNext }) {
  return (
    <div className="text-center">
      <h1 className="text-2xl font-bold mb-2">Welcome to ReportMaster</h1>
      <p className="mb-4">Generate professional reports in minutes, tailored for your needs.</p>
      <button className="bg-blue-600 text-white px-5 py-2 rounded" onClick={() => onNext()}>
        Start
      </button>
    </div>
  );
}